import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import type { FaqItem } from "@/types/content";

interface FaqSectionProps {
  items: FaqItem[];
  moreTo?: string;
}

export default function FaqSection({ items, moreTo }: FaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="常见问题"
        title="关于这里，你可能想先知道"
        desc="如果你对内容来源、更新节奏或线索提交还有疑问，可以先看看这些回答。"
      />

      <div className="mx-auto max-w-3xl">
        <ul className="flex flex-col gap-3">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <li key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        {moreTo && (
          <div className="mt-6 text-center">
            <Link
              to={moreTo}
              className="inline-flex cursor-pointer items-center gap-1 font-label text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              还有更多问题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}